import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { uuid } from '@/_core/utils/uuid';
import { SaveAboutBoard } from '..';
import * as storymapStoreModule from '../../../store';

export const createSaveAboutBoardCommand = async (action: storymapStoreModule.ChangeAboutBoardDescription) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const activityId = await uuid.create();

    const boardActivity: any = {
        Datetime: new Date().toJSON(),
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        Content: action.description,
        OriginalContent: state.aboutBoardDescription,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.AboutBoardTextChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    const cmd = new SaveAboutBoard(state.id, action.description);

    cmd.BoardActivity = boardActivity;

    return cmd;
};
